/** Merchandiser-facing carousel display modes (CarouselBlock `layout`). */
export const CAROUSEL_LAYOUT_AUTO = 'auto';
export const CAROUSEL_LAYOUT_PHOTOS = 'photos';
export const CAROUSEL_LAYOUT_BRAND_LOGOS = 'brand_logos';

export type CarouselLayout =
  typeof CAROUSEL_LAYOUT_AUTO | typeof CAROUSEL_LAYOUT_PHOTOS | typeof CAROUSEL_LAYOUT_BRAND_LOGOS;

/**
 * Host classes when layout is brand logos: lift max-width on 3/12 slides only and
 * use background-contain so marks are not cropped. Wider photo slides keep max-width caps.
 * Applied on `app-carousel-block`.
 */
export const CAROUSEL_BRAND_LOGOS_HOST_CLASSES = [
  'carousel-layout-brand-logos',
  '[&>div>div]:flex',
  '[&>div>div]:w-full',
  '[&>div>div]:justify-[safe_center]',
  '[&>div>div]:gap-3',
  '[&_app-carousel-slide-card-block>div.w-3\\/12]:!max-w-none',
  '[&_app-carousel-slide-card-block>div.w-3\\/12]:shrink-0',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:flex',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:min-h-28',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:items-center',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:justify-center',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:!bg-contain',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:bg-center',
  '[&_app-carousel-slide-card-block>div.w-3\\/12>a]:bg-no-repeat',
].join(' ');

export const CAROUSEL_PHOTOS_HOST_CLASS = 'carousel-layout-photos';

export function carouselBlockHostLayoutClasses(layout: string | undefined): string {
  if (layout === CAROUSEL_LAYOUT_PHOTOS) {
    return CAROUSEL_PHOTOS_HOST_CLASS;
  }
  if (layout === CAROUSEL_LAYOUT_BRAND_LOGOS) {
    return CAROUSEL_BRAND_LOGOS_HOST_CLASSES;
  }
  return '';
}
